export default {
    CANCELED: 'canceled',
    PENDING: 'pending',
    FAILED: 'failed',
    DONE: 'done',
    TIMEOUT: 'timeout'
};

export const REQUEST_STATUS = {
    CANCELED: 'canceled',
    PENDING: 'pending',
    FAILED: 'failed',
    DONE: 'done',
    TIMEOUT: 'timeout'
};